import ValidateException from "sap/ui/model/ValidateException";
import Type from "./Type";
export type MCPatternFormatOptions = {
    pattern: string; // Pattern format, e.g., email pattern
};

export default class MCPattern extends Type {
    private formatOptions: MCPatternFormatOptions;

    constructor(formatOptions: MCPatternFormatOptions) {
        super();
        this.formatOptions = formatOptions;
    }

    validateValue(value: string): void {
        if (!value) {
            throw new ValidateException("Value cannot be empty") as Error;
        }
        const regex = new RegExp(this.formatOptions.pattern);
        if (!regex.test(value)) {
            throw new ValidateException(`Value does not match the pattern: ${this.formatOptions.pattern}`) as Error;
        }
    }
}